import React from 'react';
import { Search } from 'lucide-react';

const EtudiantFilters = ({
  searchTerm,
  onSearchChange,
  selectedClasse,
  onClasseChange,
  selectedNiveau,
  onNiveauChange,
  selectedFiliere,
  onFiliereChange,
  selectedAnnee,
  onAnneeChange,
  classes,
  niveaux,
  filieres,
  anneesAcademiques
}) => {
  return (
    <div className="p-6 border-b border-gray-200 bg-gray-50">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        <div className="relative w-64">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <Search className="h-5 w-5 text-gray-400" />
          </div>
          <input
            type="text"
            placeholder="Rechercher un étudiant..."
            value={searchTerm}
            onChange={onSearchChange}
            className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-[#202654] focus:border-[#202654] sm:text-sm"
          />
        </div>
        
        <div className="flex flex-wrap gap-4">
          <select
            value={selectedClasse}
            onChange={onClasseChange}
            className="block w-40 px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-[#202654] focus:border-[#202654] sm:text-sm"
          >
            <option value="">Toutes les classes</option>
            {classes.map(classe => (
              <option key={classe.id} value={classe.id}>
                {classe.libelle}
              </option>
            ))}
          </select>

          <select
            value={selectedNiveau}
            onChange={onNiveauChange}
            className="block w-40 px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-[#202654] focus:border-[#202654] sm:text-sm"
          >
            <option value="">Tous les niveaux</option>
            {niveaux.map(niveau => (
              <option key={niveau.id} value={niveau.id}>
                {niveau.libelle}
              </option>
            ))}
          </select>

          <select
            value={selectedFiliere}
            onChange={onFiliereChange}
            className="block w-40 px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-[#202654] focus:border-[#202654] sm:text-sm"
          >
            <option value="">Toutes les filières</option>
            {filieres.map(filiere => (
              <option key={filiere.id} value={filiere.id}>
                {filiere.libelle}
              </option>
            ))}
          </select>

          <select
            value={selectedAnnee}
            onChange={onAnneeChange}
            className="block w-40 px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-[#202654] focus:border-[#202654] sm:text-sm"
          >
            <option value="">Toutes les années académiques</option>
            {anneesAcademiques.map(annee => (
              <option key={annee.id} value={annee.id}>
                {annee.libelle}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
};

export default EtudiantFilters;
